import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { InputAutoSuggest } from '../../../../../common/custom-form/input-auto-suggest.component';
import { MAX_LENGTH } from "../../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField } from '../../../../../common/custom-form/select-filter.component';
import { hrDetailsActions } from '../../../../../../store/external/manage-user/form/manage-user-form.reducer';
import CustomSearchableSelectWrapper from "../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';
class LineManager extends Component {
    constructor(props) {
        super(props);
        this.state ={
            isCollapsed: true
        }

        this.FirstLineManagerHrIdAutoSuggest = React.createRef();
    }

    handleToggle = () =>{
        this.setState(prev => ({isCollapsed: !prev.isCollapsed}))
    }

    onChangeFirstLineManagerHrId = async (propsName, value) => {
        this.props.FormChange(propsName, value)   
        await this.props.selectLineManager('LineManagerHrId', value); 
    }

    handleLineManagerSearch = (query)=>{
        this.setState({ searchTerm: query });  
        this.props.getHrLineManager(1, query);

        if (query === "" || query === null) {
            this.props.resetHrLineManagerDetails();
        }
    }

    loadMoreLineManager = (searchString)=>{
        const { manageUserHrDetails } = this.props;
        this.props.getHrLineManager(manageUserHrDetails.lineManagerPage + 1, searchString);
    }

    render() {
        const { isCollapsed} = this.state;
        const { translator, manageUserHrDetailsForm, manageUserHrDetails } = this.props;

        return (
            <div className="control-container">
            <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={this.handleToggle} label={translator("line_manager_details")} >
                <div className={`add-sim-container detail-page-container details-4-col-container`}>
                <CustomSearchableDropdownWrapper 
                    label={`${translator("first_line_manage_hr_sap_id")}`}
                    options={manageUserHrDetails.lineManagerDropdownList}
                    selected={manageUserHrDetails.lineManagerDropdownList.length > 0 ? manageUserHrDetailsForm.firstLineManagerHrId : null}
                    onChange={(e) => this.onChangeFirstLineManagerHrId('manageUserHrDetailsForm.firstLineManagerHrId', e)}                    
                    placeholder={`Select...`}
                    fieldProp="manageUserHrDetailsForm.firstLineManagerHrId"
                    tagName='Key'
                    optionLabelKey={{
                        Key: 'Key',
                        Value: 'Value'
                    }}
                    maxLength={MAX_LENGTH.limit_100}
                    onSearchChange={this.handleLineManagerSearch}
                    onLoadMore={this.loadMoreLineManager}
                    isLoading={manageUserHrDetails.isLineManagerLoading}
                    hasMore={manageUserHrDetails.hasMoreLineManager}
                />
                 <InputField
                    className="form-control"
                    type="text"
                    label={translator("full_name")}
                    value={manageUserHrDetailsForm.firstLineManagerFullName}
                    fieldProp="fieldProp"
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={translator("email_address_capital")}
                    value={manageUserHrDetailsForm.firstLineManagerEmailAddress}
                    fieldProp="fieldProp"
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={translator("status")}
                    value={manageUserHrDetailsForm.firstLineManagerStatus}
                    fieldProp="fieldProp"
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={true}
                />

                <InputField
                    className="form-control"
                    type="text"
                    label={translator("second_line_manage_hr_sap_id")}
                    value={manageUserHrDetailsForm.secondLineManagerHrId}
                    fieldProp="fieldProp"
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={translator("full_name")}
                    value={manageUserHrDetailsForm.secondLineManagerFullName}
                    fieldProp="fieldProp"
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={translator("email_address_capital")}
                    value={manageUserHrDetailsForm.secondLineManagerEmailAddress}
                    fieldProp="fieldProp"
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={translator("status")}
                    value={manageUserHrDetailsForm.secondLineManagerStatus}
                    fieldProp="fieldProp"
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={true}
                />
                </div>
            </CustomDropdown>
        </div>
        );
    }
}
export default connect(
    state => {
        const { manageUserHrDetails, translation } = state;
        const { manageUserHrDetailsForm } = state.form;

        return {
            manageUserHrDetails,
            manageUserHrDetailsForm,
            ...translation
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, hrDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(LineManager);